import React, { Suspense } from "react"
import Bugsnag from "../layout/bugsnag"
import { BrowserRouter as Router } from "react-router-dom"
import { UserProvider } from "hooks/use-current-user"
import { PromoCodeProvider } from "hooks/use-promo-code"
import { initialize, request } from "react-rb"
import { FormConfig } from "@convertkit/design/use-form"
import { Toaster } from "@convertkit/design/toast"
import { Features } from "core/features"

// These imports are required to get banners to show up on all app pages.
/* eslint-disable-next-line no-unused-vars */
import ApprovalBanner from "app/account/approval-banner"
/* eslint-disable-next-line no-unused-vars */
import BillingRequiredBanner from "app/account/billing-required-banner"
/* eslint-disable-next-line no-unused-vars */
import UnconfirmedSendAddressBanner from "app/account/unconfirmed-send-address-banner"

const submit = async (url, options) => {
  const { data } = await request(url, options)
  return data
}

function Layout({ children }) {
  // Toggle menu display on React pages
  React.useEffect(() => {
    const btn = document.querySelector('[data-target="#main-navbar"]')
    const menu = document.getElementById("main-navbar")

    const toggleMenu = () => {
      menu.classList.toggle("collapse")
    }
    btn && btn.addEventListener("click", toggleMenu)

    return () => {
      btn && btn.removeEventListener("click", toggleMenu)
    }
  }, [])

  return (
    <Bugsnag>
      <Features>
        <UserProvider>
          <PromoCodeProvider>
            <FormConfig request={submit}>
              <Router>
                <Suspense fallback={<div />}>{children}</Suspense>
                <Toaster />
              </Router>
            </FormConfig>
          </PromoCodeProvider>
        </UserProvider>
      </Features>
    </Bugsnag>
  )
}

function setup() {
  initialize({ layout: Layout })
}

if (document.readyState === "complete") {
  setup()
} else {
  document.addEventListener("DOMContentLoaded", setup)
}
